<div class="detail-container">
  <nb-card [nbSpinner]="saving() || loading()">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>{{ tenantType() | tenantType }}</h5>
      @if (canEdit() && !isNew() && !onFolderTab()) {
        <wr-edit-delete-button-group (edit)="onEdit()" (delete)="onDelete()"></wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (form()) {
        @if (isNew()) {
          <nb-alert>
            <div class="info-alert">
              <nb-icon icon="info-outline" pack="eva"></nb-icon>
              <span>Beim Erstellen von {{ tenantType() }} wird automatisch ein Admin-Benutzer
                    ([name]-admin) mit einem zufälligen Passwort angelegt. Das Passwort wird nach dem
                    Speichern einmalig angezeigt — bitte notieren. Der Admin muss es beim ersten Login ändern.</span>
            </div>
          </nb-alert>
        }
        <nb-tabset (changeTab)="tabChanged($event)">
          <nb-tab tabTitle="Grunddaten">
            <form [formGroup]="form()!">
              <div class="sub-card-body">
                <input hidden formControlName="id">
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="name">Name</label>
                    <input fullWidth id="name" type="text" nbInput formControlName="name"
                           [readonly]="!isEditing()" required>
                    @if (hasError('name')) {
                      <div class="error">Name ist erforderlich!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="nameAddition">Zusatz</label>
                    <input fullWidth id="nameAddition" type="text" nbInput
                           formControlName="nameAddition" [readonly]="!isEditing()">
                  </div>
                  <div class="col-4">
                    <label class="label" for="color">Farbe</label>
                    <wr-color-preset-picker formControlName="color"></wr-color-preset-picker>
                    @if (hasError('color')) {
                      <div class="error">Farbe ist erforderlich!</div>
                    }
                  </div>
                </div>
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="email">Email</label>
                    <input fullWidth id="email" type="text" nbInput formControlName="email">
                    @if (hasError('email')) {
                      <div class="error">Email ist erforderlich oder fehlerhaft!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="phone">Telefonnummer</label>
                    <input fullWidth id="phone" type="text" nbInput formControlName="phone">
                    @if (hasError('phone')) {
                      <div class="error">Telefonnummer ist erforderlich!</div>
                    }
                  </div>
                  @if (tenantType() === 'Contractor') {
                    <div class="col-4">
                      <label class="label" for="pin">Pin</label>
                      <wr-pin-input [canEdit]="canEdit()" id="pin" formControlName="pin"></wr-pin-input>
                    </div>
                    <div class="col-4">
                      <div class="contact-person-group">
                        <label class="label" for="contactPerson">Kontaktperson</label>
                        <nb-form-field class="contact-person-content">
                          <input id="contactPerson"
                                 fullWidth
                                 type="text"
                                 nbInput
                                 [value]="getContactPersonName()"
                                 [placeholder]="'Nicht zugewiesen'"
                                 class="muted-placeholder"
                                 [readonly]="true"
                                 [disabled]="!isEditing()">
                          @if (isEditing()) {
                            <button nbSuffix nbButton type="button"
                                    status="primary"
                                    ghost
                                    nbTooltip="Kontaktperson auswählen"
                                    (click)="openContactPersonDialog()">
                              <nb-icon pack="eva" icon="edit-outline"></nb-icon>
                            </button>
                          }
                        </nb-form-field>
                        @if (!getContactPersonName()) {
                          <small class="hint">Noch keine Kontaktperson zugeordnet.</small>
                        }
                      </div>
                    </div>
                  }
                  @if (tenantType() === 'External') {
                    <div class="col-4">
                      <label class="label" for="date">Vertragsdatum</label>
                      <input nbInput id="date" formControlName="contractDateText" fullWidth
                             placeholder="Datum"
                             [nbDatepicker]="datepicker">
                      <nb-datepicker #datepicker></nb-datepicker>
                    </div>
                  }
                </div>
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="homePage">Website</label>
                    <input fullWidth type="text" nbInput id="homePage" formControlName="homePage"
                           [readonly]="!isEditing()">
                  </div>
                  <div class="col-4">
                    <label class="label" for="companyRegisterNumber">Firmenbuchnummer</label>
                    <input fullWidth type="text" nbInput id="companyRegisterNumber"
                           formControlName="companyRegisterNumber" [readonly]="!isEditing()">
                  </div>
                  <div class="col-4">
                    <label class="label" for="court">Gericht</label>
                    <input fullWidth type="text" nbInput id="court" formControlName="court"
                           [readonly]="!isEditing()">
                  </div>
                </div>
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="iban">IBAN</label>
                    <input fullWidth id="iban" type="text" nbInput formControlName="iban"
                           [readonly]="!isEditing()">
                  </div>
                  <div class="col-4">
                    <label class="label" for="bic">BIC</label>
                    <input fullWidth id="bic" type="text" nbInput formControlName="bic"
                           [readonly]="!isEditing()">
                  </div>
                  @if (tenantType() === 'Internal') {
                    <div class="col-4">
                      <label class="label" for="worksWithOenorm">Önorm Begehung</label>
                      <div>
                        <nb-toggle id="worksWithOenorm" formControlName="worksWithOenorm"
                                   [disabled]="!isEditing()"></nb-toggle>
                      </div>
                    </div>
                    <div class="col-4">
                      <label class="label" for="usesRiskAssessmentByDefault">Risikoanalyse standardmäßig anzeigen</label>
                      <div>
                        <nb-toggle id="usesRiskAssessmentByDefault"
                                   formControlName="usesRiskAssessmentByDefault"
                                   [disabled]="!isEditing()"></nb-toggle>
                      </div>
                    </div>
                    @if (canEditIncompleteUpload()) {
                      <div class="col-4">
                        <label class="label" for="allowIncompleteInspectionUpload">Unfertige Begehung hochladen</label>
                        <div>
                          <nb-toggle id="allowIncompleteInspectionUpload"
                                     formControlName="allowIncompleteInspectionUpload"
                                     [disabled]="!isEditing()"></nb-toggle>
                        </div>
                      </div>
                    }
                    @if (canEditCatalogSource() && !isNew()) {
                      @if (form()?.get('catalogSourceTenantId')?.value) {
                        <div class="col-12">
                          <wr-banner [icon]="{ icon: 'info-outline', pack: 'eva' }"
                                     status="info"
                                     message="Diese Firma nutzt den Katalog (Prüfpunkte, Feststellungen, Aktionen, Textbausteine, TGA-Typen, Protokolltypen, Felder, Tags) der Katalog-Quelle und kann keine eigenen Katalogobjekte anlegen.">
                          </wr-banner>
                        </div>
                      } @else if (tenant()?.catalogSourceTenantId) {
                        <div class="col-12">
                          <wr-banner [icon]="{ icon: 'alert-triangle-outline', pack: 'eva' }"
                                     status="warning"
                                     message="Beim Speichern wird die Katalog-Übernahme gelöst — die Firma steht danach mit leerem Katalog da; bestehende Begehungen, Vorlagen und TGAs behalten ihre Referenzen.">
                          </wr-banner>
                        </div>
                      }
                    }
                    @if (canManageCorporateGroup()) {
                      <div class="col-4">
                        <label class="label">Konzern</label>
                        <wr-corporate-group-select formControlName="corporateGroupId"></wr-corporate-group-select>
                      </div>
                    }
                    @if (canEditCatalogSource() && !isNew()) {
                      <div class="col-4">
                        <label class="label">Katalog-Quelle (Konzern-Firma)</label>
                        <wr-catalog-source-tenant-select formControlName="catalogSourceTenantId"
                                                         [corporateGroupId]="form()?.get('corporateGroupId')?.value"
                                                         [excludeTenantId]="tenant()?.id">
                        </wr-catalog-source-tenant-select>
                      </div>
                    }
                  }
                </div>
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="street">Straße</label>
                    <input fullWidth id="street" type="text" nbInput formControlName="street"
                           [readonly]="!isEditing()"
                           required>
                    @if (hasError('street')) {
                      <div class="error">Straße ist erforderlich!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="number">Nummer</label>
                    <input fullWidth id="number" type="text" nbInput formControlName="number"
                           [readonly]="!isEditing()" required>
                    @if (hasError('number')) {
                      <div class="error">Nummer ist erforderlich!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="zipCode">Postleitzahl</label>
                    <input fullWidth id="zipCode" type="text" min="0" max="10000" step="1" nbInput
                           formControlName="zipCode"
                           [readonly]="!isEditing()" required>
                    @if (hasError('zipCode')) {
                      <div class="error">Postleitzahl ist erforderlich!</div>
                    }
                  </div>
                </div>
                <div class="grid">
                  <div class="col-4">
                    <label class="label" for="city">Stadt</label>
                    <input fullWidth id="city" type="text" nbInput formControlName="city"
                           [readonly]="!isEditing()" required>
                    @if (hasError('city')) {
                      <div class="error">Stadt ist erforderlich!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="state">Bundesland</label>
                    <input fullWidth id="state" type="text" nbInput formControlName="state"
                           [readonly]="!isEditing()"
                           required>
                    @if (hasError('state')) {
                      <div class="error">Bundesland ist erforderlich!</div>
                    }
                  </div>
                  <div class="col-4">
                    <label class="label" for="country">Land</label>
                    <input fullWidth id="country" type="text" nbInput formControlName="country"
                           [readonly]="true">
                  </div>
                </div>
                <div class="grid">
                  <div class="col-12">
                    <label class="label" for="description">Beschreibung</label>
                    <textarea id="description" nbInput fullWidth formControlName="description"
                              rows="5"></textarea>
                  </div>
                </div>
                <div class="grid">
                  <div class="col-6">
                    <label class="label" for="smallLogoReference">Kleines Logo</label>
                    <wr-single-attachment-control formControlName="smallLogoReference"
                                                  type="IMAGE"
                                                  singleAttachmentName="Kleines Logo löschen">
                    </wr-single-attachment-control>
                  </div>
                  <div class="col-6">
                    <label class="label" for="largeLogoReference">Großes Logo</label>
                    <wr-single-attachment-control formControlName="largeLogoReference"
                                                  type="IMAGE"
                                                  singleAttachmentName="Großes Logo löschen">
                    </wr-single-attachment-control>
                  </div>
                </div>
              </div>
            </form>
          </nb-tab>
          @if (tenantType() === 'Internal') {
            <nb-tab [tabTitle]="'Druckeinstellungen'">
              <form [formGroup]="form()!">
                <div class="sub-card-body">
                  <div class="grid">
                    <div class="col-12">
                      <label class="label" for="certificateTitle">Zertifikat Titel</label>
                      <input fullWidth id="certificateTitle" type="text" nbInput
                             formControlName="certificateTitle">
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col-12">
                      <label class="label" for="signatureName">Unterschrift Name</label>
                      <input fullWidth id="signatureName" type="text" nbInput
                             formControlName="signatureName">
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col-12">
                      <label class="label" for="longListTitle">Longlist Titel</label>
                      <input fullWidth id="longListTitle" type="text" nbInput
                             formControlName="longListTitle">
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col-12">
                      <label class="label" for="signatureReference">Signatur</label>
                      <wr-single-attachment-control formControlName="signatureReference"
                                                    type="IMAGE"
                                                    singleAttachmentName="Signatur löschen">
                      </wr-single-attachment-control>
                    </div>
                  </div>
                </div>
              </form>
            </nb-tab>
          }
          @if (!isNew() && tenantType() === 'Internal' && canEditHiddenPdfTypes()) {
            <nb-tab tabTitle="Downloads">
              <div class="sub-card-body">
                <wr-banner status="info"
                           [icon]="{ icon: 'info-outline', pack: 'eva' }"
                           message="Abgewählte Downloads werden für diesen Kunden bei Begehungen ausgeblendet — inklusive bereits generierter Dokumente und Freigabe-Links. Als Pflicht markierte Dokumente müssen generiert sein, bevor die Begehungs-E-Mail versendet werden kann. Bei „HORA-Pass anhängen“ wird der HORA-Pass des Gebäudes beim Generieren als letzte Seiten angehängt.">
                </wr-banner>
                <div class="pdf-type-list">
                  <div class="pdf-type-row pdf-type-header">
                    <span class="label">Download</span>
                    <span class="label">Pflicht für E-Mail</span>
                    <span class="label">HORA-Pass anhängen</span>
                  </div>
                  @for (option of pdfOptions; track option.type) {
                    <div class="pdf-type-row">
                      <nb-checkbox
                        [checked]="isPdfTypeVisible(option.type)"
                        [disabled]="!isEditing()"
                        (checkedChange)="togglePdfType(option.type, $event)">
                        {{ option.label }}
                      </nb-checkbox>
                      <nb-checkbox
                        class="email-required-checkbox"
                        [checked]="isPdfTypeEmailRequired(option.type)"
                        [disabled]="!isEditing() || !isPdfTypeVisible(option.type) || option.emailRequirable === false"
                        (checkedChange)="toggleEmailRequired(option.type, $event)">
                      </nb-checkbox>
                      <nb-checkbox
                        class="hora-pass-checkbox"
                        [checked]="isPdfTypeHoraPass(option.type)"
                        [disabled]="!isEditing() || !isPdfTypeVisible(option.type) || option.horaPassAppendable === false"
                        (checkedChange)="toggleHoraPass(option.type, $event)">
                      </nb-checkbox>
                    </div>
                  }
                </div>
              </div>
            </nb-tab>
          }
          @if (currentTenant()?.type === 'External') {
            <nb-tab tabTitle="Erweiterte Daten">
              <wr-tenant-contractor-external-config-page
                [form]="form()!"
                [isEditing]="isEditing()"
                [contractorId]="tenantId()"
                [firstSubmit]="firstSubmit()"
                [tenantType]="tenantType()"
              ></wr-tenant-contractor-external-config-page>
            </nb-tab>
          }
          @if (!isNew() && canSeeFolders() && tenantType() === 'External') {
            <nb-tab tabTitle="Gebäude Ordner">
              <wr-attachment-folder-overview-page [tenantId]="tenantId()"></wr-attachment-folder-overview-page>
            </nb-tab>
          }
          @if (!isNew() && canSeeFolders() && tenantType() === 'Internal') {
            <nb-tab tabTitle="TGA Ordner">
              <wr-attachment-folder-overview-page
                [tenantId]="tenantId()"
                [folderModuleType]="'TGA_DOCUMENTS'"></wr-attachment-folder-overview-page>
            </nb-tab>
          }
          @if (!isNew() && tenantType() === 'External' && canViewGuidelines()) {
            <nb-tab tabTitle="Leitfäden">
              <wr-tenant-guidelines-config
                [externalTenantId]="tenantId()"
                [internalTenantId]="currentTenant()?.id"
                [canEdit]="canEditGuidelines() && isEditing()">
              </wr-tenant-guidelines-config>
            </nb-tab>
          }
        </nb-tabset>
      }
    </nb-card-body>
    @if (canEdit() && !onFolderTab()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing()" nbButton status="primary" (click)="submit()">Speichern
        </button>
        <button size="medium" [disabled]="!isEditing()" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
